import React, { useEffect, useState } from 'react';
import { Controller, useWatch } from 'react-hook-form';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { TextFieldDate as TextFieldDateDay, TextFieldNoneDate as TextFieldNoneDateDay } from '../DateTime/style.js';
import { CssDateField } from 'components/InputYupAndMui/constant.js';

const DateDay = (props) => {
  const {
    label,
    defaultValue,
    onChangeHandle,
    name,
    error,
    isRequired,
    placeholder,
    sizeDate,
    setValue,
    control,
    register,
    isShowModal,
    minDate,
    maxDate,
    disabled,
    isReadOnly,
  } = props;
  
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);  
    } else {
      if (isShowModal !== undefined && !isShowModal) {
        setValue(name, null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, setValue, isShowModal]);

  const handleChangeDate = (newValue) => {
    setValue(name, newValue);

    if (onChangeHandle) {
      onChangeHandle(newValue);
    }
  };

  // Watch value of input date
  const valueWatch = useWatch({
    control,
    name: name,
  });

  return (
    <>
      <CssDateField labelspace={valueWatch ? 0 : '-1px'}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Controller
            render={({ field }) => (
              <DesktopDatePicker
                fullWidth
                name={name}
                open={open}
                inputFormat="dd/MM/yyyy"
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={field.value}
                label={
                  <React.Fragment>
                    {placeholder && !field.value ? placeholder : label}
                    {isRequired && label ? <sup>*</sup> : ''}
                  </React.Fragment>
                }
                onChange={handleChangeDate}
                inputProps={{
                  style: sizeDate ? { fontSize: '14px' } : { padding: '14px 15px 14px 15px', fontSize: '14px' },
                  readOnly: true,
                  disabled: isReadOnly ? true : false,
                }}
                renderInput={(params) => {
                  if (label) {
                    return <TextFieldDateDay {...params} {...register(name)} error={error ? true : false} />;
                  }
                  return <TextFieldNoneDateDay {...params} {...register(name)} error={error ? true : false} />;
                }}
                minDate={minDate ? new Date(`${minDate}`) : null}
                maxDate={maxDate ? new Date(`${maxDate}`) : null}
                disabled={disabled}
              />
            )}
            control={control}
            name={name}
          />
        </LocalizationProvider>
      </CssDateField>
      <p className="error-input error">{error}</p>
    </>
  );
};

export default DateDay;
